import script from "./dictCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./dictCheck.vue?vue&type=script&setup=true&lang=js"

import "./dictCheck.vue?vue&type=style&index=0&id=0c885c60&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c885c60"]])

export default __exports__